var render, staticRenderFns
import script from "./OrderResultHeaderLine.vue?vue&type=script&lang=js&"
export * from "./OrderResultHeaderLine.vue?vue&type=script&lang=js&"
import style0 from "./OrderResultHeaderLine.vue?vue&type=style&index=0&id=2a6efa41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6efa41",
  null
  
)

export default component.exports